export default "__VITE_ASSET__Dlq4Tjvk__"